import { render, staticRenderFns } from "./FooterHome.vue?vue&type=template&id=5e966a4c&scoped=true&"
import script from "./FooterHome.vue?vue&type=script&lang=js&"
export * from "./FooterHome.vue?vue&type=script&lang=js&"
import style0 from "./FooterHome.vue?vue&type=style&index=0&id=5e966a4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e966a4c",
  null
  
)

export default component.exports